import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import {
    showHideModalAddVerificacionSOMA,
    updateInputs,
    uploadVerificacionSSTFile,
    storeVerificacionSST,
} from '../../actions/common'
import { acceptedFiles } from '../../utils/helpers'
const filesTypes = acceptedFiles.map(x => x.type).join()


class ModalAddVerificacionSOMA extends Component {

    handleCloseModal = () => {
        const modal = document.getElementById('modalAddVerificacionSOMA')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalAddVerificacionSOMA .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalAddVerificacionSOMA(false), 300)
    }

    handleOnDrop = (files) => {
        if (files.length > 1) {
            toast.warn(`Solo es permitido procesar un archivo a la vez`, { bodyClassName: 'toastify-content toastify-warning' })
            return
        }
        this.props.uploadVerificacionSSTFile(files[0])
    }

    handleOnRejected = (files) => {
        files.forEach(x => {
            toast.warn(`El archivo ${x.name} no es del tipo esperado. ${x.type}`, { bodyClassName: 'toastify-content toastify-warning' })
        })
    }

	setIcon = (icon) => {
		if (icon) {
			const imageSrc = require('../../img/16px/' + icon)
			return <img src={ imageSrc } />
		}
		return null
	}

    render() {
        const { modalAddVerificacionSOMA } = this.props
        if (!modalAddVerificacionSOMA.get('show')) {
            return null
        }

        return(
            <Modal id="modalAddVerificacionSOMA" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ `Verificación Salud Ocupacional y Medio Ambiente SOMA` } onClose={ e => this.handleCloseModal(e, "modalAddVerificacionSOMA") } />
                <ModalButtonStrip>
                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
                        onClick={ e => this.props.storeVerificacionSST() }
                    />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
						<div className="row">
							<div className="col-md-12">
                                <Dropzone accept={ filesTypes } onDropAccepted={ this.handleOnDrop } onDropRejected={ this.handleOnRejected } className="dropzone1">
                                    <p>Arrastre los soportes a esta sección</p>
                                </Dropzone>
							</div>
						</div>
						<div className="row" style={{ marginTop: '10px' }}>
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Nombre del archivo</label>
									<div className="div-input-sm">
										{
											(modalAddVerificacionSOMA.getIn(['data', 'file']) &&
												<div style={{ paddingTop: '1px' }}>
													<span>{ this.setIcon(modalAddVerificacionSOMA.getIn(['data', 'icono'])) }</span>
													<span style={{ marginLeft: '4px', verticalAlign: 'bottom' }}>{ modalAddVerificacionSOMA.getIn(['data', 'file']).name }</span>
													<span style={{ marginLeft: '3px', verticalAlign: 'bottom', color: '#ccc' }}>({ numeral(modalAddVerificacionSOMA.getIn(['data', 'file']).size).format('0.0 b') })</span>
												</div>
											)
										}
									</div>
								</div>
							</div>
						</div>
                        <div className="row">
                            <div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Observaciones</label>
									<textarea className="form-control input-sm" rows={4} value={ modalAddVerificacionSOMA.getIn(['data', 'observaciones']) || '' } onChange={ (e) => this.props.updateInputs('modalAddVerificacionSOMA.data.observaciones', e.target.value) } />
								</div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <h4>Evaluación del servicio recibido</h4>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '70%' }}>Criterio</th>
                                            <th style={{ width: '30%' }}>Calificación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Calificación</td>
                                            <td>
                                                <select className="form-control input-sm" value={ modalAddVerificacionSOMA.getIn(['data', 'aceptado']) || -1 } onChange={ (e) => this.props.updateInputs(`modalAddVerificacionSOMA.data.aceptado`, e.target.value) }>
                                                    <option value={ -1 } disabled>Seleccione una opción</option>
                                                    <option value={ 1 }>Aceptado</option>
                                                    <option value={ 0 }>No aceptado</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalAddVerificacionSOMA: state.common.get('modalAddVerificacionSOMA'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalAddVerificacionSOMA: (show) => dispatch(showHideModalAddVerificacionSOMA(show)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        uploadVerificacionSSTFile: (file) => dispatch(uploadVerificacionSSTFile(file)),
        storeVerificacionSST: (last) => dispatch(storeVerificacionSST(last)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddVerificacionSOMA)


// WEBPACK FOOTER //
// ./src/components/Documentos/ModalAddVerificacionSOMA.jsx